// DS1.15
import React from 'react';
import classnames from 'classnames';
import { PapiUser } from '@wix/da-papi-types';
import Flex from '@wix/da-ds/pkg/Flex';
import UserAvatar from '../Avatar';
import UserLink from '../Link';

import s from './UserIdentity.scss';

export interface Props {
  size: 'small' | 'big';
  user: PapiUser;
  timestamp?: string;
  className?: string;
}

const UserIdentity: React.FC<Props> = ({
  size,
  user,
  timestamp,
  className,
}) => (
  <Flex
    className={classnames(s[size], timestamp && s['with-timestamp'], className)}
    alignItems="center"
  >
    <UserAvatar
      user={user}
      className={s['avatar']}
      size={size === 'small' ? 24 : 32}
    />
    <div className={s['details']}>
      <UserLink user={user} className={s['userlink']} />
      {timestamp && <div className={s['timestamp']}>{timestamp}</div>}
    </div>
  </Flex>
);
UserIdentity.displayName = 'UserIdentity';

export default UserIdentity;
